/**
 * @generated SignedSource<<e733bda4006075e198d0bb2fe75f8b7f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ExternalSpaceSubtype = "BUSINESS" | "DRIVE" | "PROJECT" | "SERVICE_DESK" | "SITE" | "SOFTWARE" | "SPACE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphJiraDc_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly entity: {
    readonly container?: {
      readonly displayName?: string | null;
      readonly subtype?: ExternalSpaceSubtype | null;
      readonly url?: string | null;
    } | null;
  } | null;
  readonly excerpt: string | null;
  readonly id: string;
  readonly integrationId: string | null;
  readonly lastModifiedDate: string | null;
  readonly permissionLevel: string | null;
  readonly subtype: string | null;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphJiraDcProject_AtlassianSearchPage" | "searchGraphJiraDcWorkItem_AtlassianSearchPage">;
  readonly " $fragmentType": "searchGraphJiraDc_AtlassianSearchPage";
};
export type searchGraphJiraDc_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphJiraDc_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphJiraDc_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v1 = {
  "kind": "ScalarField",
  "name": "url"
},
v2 = [
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "displayName"
          },
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "type": "ExternalSpace"
      }
    ]
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphJiraDc_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "integrationId"
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "title"
    },
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "kind": "ScalarField",
      "name": "excerpt"
    },
    {
      "kind": "ScalarField",
      "name": "permissionLevel"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "ExternalComment"
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "ExternalProject"
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "ExternalWorkItem"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphJiraDcProject_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphJiraDcWorkItem_AtlassianSearchPage"
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "80e470e81e5ff9e507416cdfb6a7b7a6";

export default node;
